import { render, staticRenderFns } from "./message-list_all.vue?vue&type=template&id=46827aee&scoped=true"
import script from "./message-list_all.vue?vue&type=script&lang=js"
export * from "./message-list_all.vue?vue&type=script&lang=js"
import style0 from "./message-list_all.vue?vue&type=style&index=0&id=46827aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46827aee",
  null
  
)

export default component.exports